import { render, staticRenderFns } from "./tool-bar.vue?vue&type=template&id=274b4fcf&scoped=true&"
import script from "./tool-bar.vue?vue&type=script&lang=js&"
export * from "./tool-bar.vue?vue&type=script&lang=js&"
import style0 from "./tool-bar.vue?vue&type=style&index=0&id=274b4fcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b4fcf",
  null
  
)

export default component.exports